import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./useTableData";

export const ScrapTable = () => {
	const classes = useTableStyles();
	const {
		state: { scrapData },
	} = useHeatReportContext();

	const { columns } = useTableData();

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div style={{ height: "11.5rem" }}>
						<AgGridReact
							rowData={scrapData}
							columnDefs={columns}
							domLayout="normal"
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							getRowId={(params) => params.data.ScrapId}
							suppressContextMenu
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
